const BankIdSigningActions = {
  MOBILE: 1,
  QR_CODE: 2
}

const PowerOfAttorneySignStatus = {
  SIGNED: '1',
  UNSIGNED: '2'
}

const PowerOfAttorneyStatus = {
  ACTIVE: '1',
  INACTIVE: '2'
}

const PowerOfAttorneyTypes = {
  AUDIO: 1,
  PAPER: 3,
  WEBBPOA: 4,
  BANKID: 5
}

export { BankIdSigningActions, PowerOfAttorneyStatus, PowerOfAttorneySignStatus, PowerOfAttorneyTypes }
